import Field from '@core/managers/Field';
import { Form } from '@core/managers/Form';
import {
  TEventReducedSchema,
  TEventsKeys,
  TFormEventDirectives,
  TObserverData,
} from '@core/types';

export type TEventPublishPayload = {
  checksum?: string;
} & {
  [key in string]?: unknown;
};

export type TEventInformation<T> = TObserverData<T> & {
  eventReducedSchema: TEventReducedSchema;
  formEventDirectives: TFormEventDirectives;
  form: Form;
  field: Field;
  coreEvent: TEventsKeys;
};

/* eslint-disable @typescript-eslint/no-explicit-any */

export enum EFlowLogging {
  OBSERVER = 'OBSERVER',
  REACT_FIELD_ADAPTER = 'REACT FIELD ADAPTER',
  FIELD_HANDLER = 'FIELD HANDLER',
}

export type TLoggingEvent = {
  level: 'error' | 'info';
  data?: any;
  flow: EFlowLogging;
  action: string;
  error?: any;
};
